import { useAuthentication } from "hooks/useAuthentication";
import useAutoLogout from "hooks/useAutoLogOut";
import Routes from "./routes";
import AutoRedirect from "./components/AutoRedirect";

function App() {
  const {authProvider:{signOut}} = useAuthentication()
  useAutoLogout(signOut, 1500000);
  return (
      <>
        {/* <AutoRedirect /> */}
        <Routes />
      </>
  );
}

export default App;
